
import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import LoaderSpinner from "~/components/LoaderSpinner.vue";
import ShipSteps from "~/components/ship/ShipSteps.vue";
import Event from "~/entities/Event";

export default Vue.extend({
  name: "EventDetails",
  components: { ShipSteps, LoaderSpinner },
  layout: "WithServices",

  data() {
    return {
      isLoading: true as boolean,
      selectedEvent: {} as Event,
      parsedBB: undefined as any,
    };
  },
  computed: {
    ...mapGetters({
      activeNotices: "errorsBag/activeNotices" as any,
      alertResponses: "errorsBag/alertResponses" as any,
      loading: "loading",
      stepNumber: "ship/stepNumber",
      stepName: "ship/stepName",
      events: "eventShipping/events",
      currentEvent: "eventShipping/currentEvent",
      eventId: "eventShipping/eventId",
    }),
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
      setBoxes: "ship/setBoxes",
      setTrips: "ship/setTrips",
      setUnits: "ship/setUnits",
      setPurpose: "ship/setPurpose",
      setShipMode: "ship/setShipMode",
      setDetails: "ship/setDetails",
      setStepName: "ship/setStepName",
      setStepNumber: "ship/setStepNumber",
      setInputOptions: "ship/setInputOptions",
      setCurrentEvent: "eventShipping/setCurrentEvent",
      setEventId: "eventShipping/setEventId",
      setEventName: "eventShipping/setEventName",
    }),
    ...mapActions({
      getEvents: "eventShipping/getEvents",
      getCurrentEvent: "eventShipping/getCurrentEvent",
      searchEvent: "eventShipping/searchEvent",
      getEventByUrl: "eventShipping/getEventByUrl",
    }),
    parseDateJs(startDate: string, endDate: string) {
      const parseStartDate = startDate ? new Date(startDate) : null;
      const parseEndDate = endDate ? new Date(endDate) : null;

      if (
        parseStartDate &&
        parseEndDate &&
        parseStartDate.getTime() !== parseEndDate.getTime()
      ) {
        const [startYear, endYear] = [
          parseStartDate.getFullYear(),
          parseEndDate.getFullYear(),
        ];
        const [startMonth, endMonth] = [
          parseStartDate.getMonth(),
          parseEndDate.getMonth(),
        ];
        const [startDay, endDay] = [
          parseStartDate.getDate(),
          parseEndDate.getDate(),
        ];

        if (startYear !== endYear) {
          return `${this.getMonthName(
            startMonth
          )} ${startDay}, ${startYear} - ${this.getMonthName(
            endMonth
          )} ${endDay}, ${endYear}`;
        }
        if (startMonth !== endMonth) {
          return `${this.getMonthName(
            startMonth
          )} ${startDay} - ${this.getMonthName(
            endMonth
          )} ${endDay}, ${startYear}`;
        }
        return `${this.getMonthName(
          startMonth
        )} ${startDay} - ${endDay}, ${startYear}`;
      } else {
        const eventDate = parseStartDate || parseEndDate;
        return `${this.getMonthName(
          eventDate?.getMonth()
        )} - ${eventDate?.getDate()}, ${eventDate?.getFullYear()}`;
      }
    },
    getMonthName(monthNumber) {
      const date = new Date();
      date.setDate(15); // Set to the middle of the month to avoid edge cases
      date.setMonth(monthNumber);
      return date.toLocaleString("en-US", { month: "short" });
    },
    changeStep(step) {
      if (step === "Search") {
        this.setStepNumber(1);
        this.setStepName("Search");
      } else if (step === "Costs") {
        this.setStepNumber(2);
        this.setStepName("Cost");
      } else if (step === "Details") {
        this.setStepNumber(3);
        this.setStepName("Details");
      } else if (step === "Contents") {
        this.setStepNumber(4);
        this.setStepName("Contents");
      } else if (step === "Payment") {
        this.setStepNumber(5);
        this.setStepName("Payment");
      }
    },
    goStep(stepName, valid) {
      if (valid) {
        this.changeStep(stepName);
      }
    },
    formatAddresses(event: Event) {
      if (event.shipLocations && event.shipLocations.length) {
        this.setInputOptions(event.shipLocations);
      } else {
        this.setInputOptions([]);
      }
    },
    formatURLs(text: string) {
      if (!text) {
        return text;
      }
      const regex = /\[url\s+href=(.*?)\s+target=(.*?)\](.*?)\[\/url\]/g;
      const replacedText = text.replace(
        regex,
        '<a href="$1" target="$2">$3</a>'
      );
      return replacedText;
    },
    formatToHtml(text: string) {
      if (!text) {
        return text;
      }
      // Replace [b] and [/b] with <b> and </b>, respectively
      text = text.replace(/\[b\]/g, "<b>");
      text = text.replace(/\[\/b\]/g, "</b>");

      // Replace [i] and [/i] with <i> and </i>, respectively
      text = text.replace(/\[i\]/g, "<i>");
      text = text.replace(/\[\/i\]/g, "</i>");

      // Replace [ul] and [/ul] with <ul> and </ul>, respectively
      text = text.replace(/\[ul\]/g, "<ul>");
      text = text.replace(/\[\/ul\]/g, "</ul>");

      // Replace [li] with <li> and add closing </li> tags
      text = text.replace(/\[li\]/g, "<li>");
      text = text.replace(/\[\/li\]/g, "</li>");

      text = text.replace(/\n\s*\n/g, "<br>");
      return "<p>" + text + "</p>";
    },
    getYear(year: string) {
      const formatYear: Date = new Date(year);
      return formatYear.getFullYear();
    },
  },
  watch: {
    currentEvent() {
      this.selectedEvent = this.currentEvent;
      this.formatAddresses(this.selectedEvent);
      this.isLoading = false;
    },
  },
  created() {
    this.setTrips([]);
    this.setEventName(this.$route.params.event);
    const eventUrlResponse = this.getEventByUrl();
    this.selectedEvent = this.currentEvent ?? this.currentEvent;
    if (!eventUrlResponse && this.eventId !== undefined && !this.currentEvent) {
      this.getCurrentEvent();
    }
    this.setStepNumber(1);
  },
  beforeDestroy() {
    this.setCurrentEvent({});
  },
});
